// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"7893c4b7","453":"1a2b70cd","510":"f5439c78","810":"55ef1fdd","950":"cc3be52a","995":"c8de3637"}[chunkId] + ".chunk.js";
};